
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/delivery/[[...slug]]",
      function () {
        return require("private-next-pages/delivery/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/delivery/[[...slug]]"])
      });
    }
  